module.exports = __webpack_public_path__ + "PinkNannies-RGB-Horizontal.svg?e649088f91402cc4d83f78ac4316a338";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/PinkNannies-RGB-Horizontal.svg
// module id = 74
// module chunks = 0